const additionalPortRequest = {
    requestingAdditionalPortRequest: false
};
export default additionalPortRequest;
